import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import trackShopInfoClicked from '@shopDetails/tracking/actions/trackShopInfoClicked';
import getGlobalDiscountsTotalAmount from '@core/reducers/menu/selectors/getGlobalDiscountsTotalAmount';
import getCartPlusInfo from '@core/reducers/cart/selectors/getCartPlusInfo';
import getCartShippingAmount from '@core/reducers/cart/selectors/getCartShippingAmount';
import getShopDetailsPickupFlag from '@funWithFlags/selectors/getShopDetailsPickupFlag';
import getUseLiveOrderTracking from '@core/reducers/shop/selectors/getUseLiveOrderTracking';
import getGlobalDiscountsWeekly from '@core/reducers/menu/selectors/getGlobalDiscountsWeekly';
import getGlobalDiscountsPickup from '@core/reducers/menu/selectors/getGlobalDiscountsPickup';

const mapStateToProps = createStructuredSelector({
  discountsTotalAmount: getGlobalDiscountsTotalAmount,
  plusSettings: getCartPlusInfo,
  shippingAmount: getCartShippingAmount,
  isPickupFlagEnabled: getShopDetailsPickupFlag,
  isLogisticsDelivery: getUseLiveOrderTracking,
  weeklyDiscount: getGlobalDiscountsWeekly,
  pickupDiscount: getGlobalDiscountsPickup,
});

const mapDispatchToProps = {
  trackShopInfoClicked,
};

export default connect(mapStateToProps, mapDispatchToProps);
